import React, { useCallback } from 'react'
import { intl } from 'lang/intl'
import { TtButton, TtIcon, TtTooltip } from '@23/react'
import {
  toggleLiveTranscriptions,
  useAreLiveTranscriptionsEnabled,
} from '../hooks/useLiveTranscriptionsOverlay'
import { useIsWebinarLiveState } from '../../../../firebase/hooks/useWebinarGlobalState'

type LiveTranscriptionsHUDState = 'disabled' | 'on' | 'off'

export const LiveTranscriptionsToggle = () => {
  const isTranscriptionEnabled = useAreLiveTranscriptionsEnabled()

  const onClickHandler = useCallback(async () => {
    toggleLiveTranscriptions()
  }, [])

  const isWebinarLive = useIsWebinarLiveState()

  const state: LiveTranscriptionsHUDState = !isWebinarLive
    ? 'disabled'
    : isTranscriptionEnabled
      ? 'on'
      : 'off'

  const buttonColor: HTMLTtButtonElement['color'] =
    state === 'on' ? 'primary' : 'secondary'

  const tooltipMessages: Record<LiveTranscriptionsHUDState, string> = {
    disabled: intl.formatMessage({
      defaultMessage:
        'Live transcriptions will be available when the webinar goes live',
    }),
    on: intl.formatMessage({
      defaultMessage: 'Hide Live Transcriptions',
    }),
    off: intl.formatMessage({
      defaultMessage: 'Show Live Transcriptions',
    }),
  }

  return (
    <TtTooltip content={tooltipMessages[state]} placement="left" distance={16}>
      <TtButton
        circle
        color={buttonColor}
        onClick={state !== 'disabled' ? onClickHandler : undefined}
        aria-label={intl.formatMessage({
          defaultMessage: 'Toggle Live Transcriptions',
        })}
      >
        <TtIcon name="subtitles" library="one/global" />
      </TtButton>
    </TtTooltip>
  )
}
